import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/712a1df08fdfde579f05f53e07bdb86a.jpg"
          alt="MARCINSKI Studio"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 lg:px-16 flex flex-col items-center">
        {/* Badge */}
        <div className="inline-flex items-center border border-white/40 px-5 py-2 mb-10">
          <span className="font-sans text-xs tracking-widest uppercase text-white/70">
            Bordeaux · Design Studio
          </span>
        </div>

        {/* Main title */}
        <h1 className="font-serif font-light text-white text-5xl lg:text-7xl xl:text-[82px] leading-tight max-w-4xl mb-8">
          Studio de design créatif et identité visuelle
        </h1>

        {/* Subtitle */}
        <p className="font-sans font-light text-white/70 text-base lg:text-lg leading-relaxed max-w-2xl mb-12 tracking-wide">
          MARCINSKI accompagne les marques, entreprises et projets indépendants dans la création
          d'identités visuelles fortes et contemporaines.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/contact"
            className="px-10 py-4 bg-white text-brand-noir font-sans text-sm tracking-widest uppercase hover:bg-brand-or hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Discuter du projet
          </Link>
          <Link
            to="/a-propos"
            className="px-10 py-4 border border-white/50 text-white font-sans text-sm tracking-widest uppercase hover:border-white hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Découvrir le studio
          </Link>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-px h-10 bg-white/30"></div>
      </div>
    </section>
  );
}
